export const text = {
  NO_PAYMENT_METHOD: 'No payment method',
  CARD_TYPE: 'Card type',
  EXP: 'Exp.',
  SELECT_CARD: 'Select card',
  ERROR: 'Error',
}
